import { themeAtom } from "Infrastructure/Theme/Atom/themeAtom";
import { SidebarItems } from "Shared/Components/Layout/Full/Sidebar/SidebarItems";
import { Scrollbar } from "Shared/Components/Scroll/Scrollbar";
import { VerticalSelector } from "Shared/Components/verticalSelector/VerticalSelector";
import { Box, Drawer } from "@mui/material";
import { useAtom } from "jotai";
import { Logo } from "../Logo/Logo";
import { CollapseSwitch } from "./CollapseSwitch";
import { Market } from "./Market";
import { Profile } from "./Profile";
import { Search } from "./Search";

type SideBarContentProps = {
	isCollapse: boolean;
	isSidebarHover: boolean;
};

const SideBarContent = ({
	isCollapse,
	isSidebarHover,
}: SideBarContentProps) => {
	const toggleDirection = () => {
		if (!isCollapse || isSidebarHover) {
			return "row";
		}
		return "column";
	};

	return (
		<Box display="flex" flexDirection="column" justifyContent="space-between">
			<Box>
				<Box display="flex" justifyContent="center">
					<Logo />
				</Box>
				<Box
					display="flex"
					flexDirection={toggleDirection()}
					pt={2}
					px={2}
					gap={2}
					alignItems="center"
					justifyContent="center"
				>
					<Search />
					<Market />
				</Box>
				<Box px={2} py={1}>
					<VerticalSelector />
				</Box>
				<Scrollbar>
					<SidebarItems />
				</Scrollbar>
			</Box>
			<Profile />
		</Box>
	);
};

export function Sidebar() {
	const [themeConfiguration, setThemeConfiguration] = useAtom(themeAtom);
	const {
		isCollapse,
		isSidebarHover,
		SidebarWidth,
		MiniSidebarWidth,
		activeMode,
	} = themeConfiguration;

	const toggleWidth = () => {
		if (!isCollapse || isSidebarHover) {
			return SidebarWidth;
		}
		return MiniSidebarWidth;
	};

	const handleMouseEnter = () => {
		if (isCollapse) {
			setThemeConfiguration({
				...themeConfiguration,
				isSidebarHover: true,
			});
		}
	};

	const handleMouseLeave = () => {
		if (isSidebarHover) {
			setThemeConfiguration({
				...themeConfiguration,
				isSidebarHover: false,
			});
		}
	};

	return (
		<Box
			sx={{
				zIndex: 0,
				flexShrink: 0,
				transition: "width 0.2s ease-in-out",
				boxShadow: activeMode === "dark" ? 0 : 1,
				width: toggleWidth(),
			}}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
		>
			<Drawer
				anchor="left"
				open
				variant="permanent"
				slotProps={{
					paper: {
						sx: {
							width: toggleWidth(),
							position: "fixed",
							border: "none",
							overflow: "scroll",
							scrollbarWidth: "none",
							height: "100%",
							top: 0,
						},
					},
				}}
			>
				<CollapseSwitch />
				<SideBarContent
					isCollapse={isCollapse ?? false}
					isSidebarHover={isSidebarHover ?? false}
				/>
			</Drawer>
		</Box>
	);
}
